(function (window, document, undefined) {
  "use strict";

  let videoButtons;

  const trackGA = (e) => {
    const button = e.target || false;

    if (!button || !dataLayer) return;

    const eventData = {
      event: "genericEvent",
      eventCategory: "video_button",
      eventAction: "click",
      eventLabel: button.href,
    };

    dataLayer.push(eventData);

    document.dispatchEvent(
      new CustomEvent("hansrmdtevent", { detail: eventData })
    );
  };

  const handleNavigation = (e) => {
    e.preventDefault();

    const button = e.currentTarget

    const currentDomain = window.location.protocol + '//' + window.location.hostname;

    if (window.history.length > 1 && document.referrer.startsWith(currentDomain)) {
      history.back();
    } else {
      const fallbackLink = button.dataset.link || button.href;

      if (fallbackLink) {
        window.location.href = fallbackLink;
      }
    }
  };

  const init = () => {
    videoButtons = document.querySelectorAll(".vodl-button-link--video");

    if (videoButtons.length > 0) {
      videoButtons.forEach((button) => {
        button.removeEventListener("click", trackGA);
        button.addEventListener("click", trackGA);
      });
    }

    const navigationButtons = document.querySelectorAll(".vodl-button-link[data-link]");

    if (navigationButtons.length > 0) {
      navigationButtons.forEach((button) => {
        button.removeEventListener("click", handleNavigation);
        button.addEventListener("click", handleNavigation);
      });
    }
  };

  init();
  document.addEventListener("newPage", init);
})(window, document);
